import React, { useState, useRef } from 'react';
import { ActivityBadge, ActivityPanel } from '@/modules/activities/components';
import { useMyActivities } from '@/modules/activities/hooks';
import { LeadQuickViewDialog } from '@/modules/crm/leads/components';

/**
 * Activities dropdown for the header/sidebar-footer
 * Shows pending activities the user needs to complete today or overdue
 *
 * O painel é renderizado via portal (position: fixed) pelo próprio ActivityPanel,
 * abrindo para CIMA e à DIREITA do trigger. Isso evita o clipping causado pelo
 * stacking context da Sidebar (classe `transform`) e pelo ancestral
 * `overflow-hidden` do MainLayout quando o trigger vive no rodapé inferior-esquerdo.
 * O clique-fora também é tratado dentro do painel (mousedown portalado).
 */
export const ActivitiesDropdown: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const triggerRef = useRef<HTMLDivElement>(null);

  // Fetch user's pending activities
  const { data } = useMyActivities(10);

  const activities = data?.activities || [];
  const total = data?.total || 0;

  return (
    <div className="relative">
      <div ref={triggerRef} className="inline-flex">
        <ActivityBadge
          count={total}
          onClick={() => setIsOpen(!isOpen)}
          isActive={isOpen}
        />
      </div>

      {isOpen && (
        <ActivityPanel
          triggerRef={triggerRef}
          activities={activities}
          total={total}
          onClose={() => setIsOpen(false)}
          onLeadClick={(leadId) => {
            setIsOpen(false);
            setSelectedLeadId(leadId);
          }}
        />
      )}

      <LeadQuickViewDialog
        leadId={selectedLeadId}
        isOpen={!!selectedLeadId}
        onClose={() => setSelectedLeadId(null)}
      />
    </div>
  );
};
